import { useApi } from "@backstage/core-plugin-api";
import { opsgenieApiRef } from "../api/OpsgenieApi";
import { useCallback, useEffect } from "react";
import { OpsgenieIncident } from "../types";
import { useAsyncFn } from "react-use";

export const useFilteredIncidentsWithPostMortems = () => {
  const api = useApi(opsgenieApiRef);

  const getFilteredIncidents = useCallback(async () => {
    const i = await api.getIncidents({
      filterFiredrills: true,
      resolved: true,
      fromDaysInPast: 30,
    });
    let filtered = await Promise.all(
      i.map(async (f: OpsgenieIncident) => {
        const pm = await api.getPostMortemIdByIncidentId({
          incidentId: f.id,
        });

        if (!pm || pm.status === "error") {
          return f;
        }

        return pm.data ? undefined : f;
      })
    );
    filtered = filtered.filter((f) => f);
    return filtered;
  }, [api]);

  const [state, fetchFilteredIncidents] = useAsyncFn(async () => {
    return await getFilteredIncidents();
  }, []);

  useEffect(() => {
    fetchFilteredIncidents();
  }, [fetchFilteredIncidents]);

  return {
    loading: state.loading,
    error: state.error,
    results: state?.value,
    refetch: fetchFilteredIncidents,
  };
};
